import routes from './routes';
import { SetRoutes } from 'components';

const ExtraStocksPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default ExtraStocksPages;
